export default __webpack_public_path__ + "static/media/warning-icon.e3a26fc8.svg";